var $ = require('jquery');

function scrollTo(element, offset) {
	$(element).animate({
      scrollTop: offset
    }, 500);
}

module.exports = scrollTo;
